import api from './api';

export interface Document {
  id: number;
  name: string;
  type: string; // 'folder' | 'file'
  mime_type?: string;
  size?: number;
  parent_id: number | null;
  path: string;
  created_at: string;
  updated_at: string;
  created_by: string;
  case_id?: number;
  client_id?: number;
  is_shared: boolean;
  thumbnail_url?: string;
}

export interface DocumentCreateInput {
  name: string;
  type: string;
  parent_id?: number | null;
  case_id?: number;
  client_id?: number;
  is_shared?: boolean;
}

export interface DocumentUpdateInput extends Partial<DocumentCreateInput> {
  id: number;
}

const documentsService = {
  getDocuments: async (userId: string, parentId: number | null = null) => {
    const response = await api.get(`/documents/${userId}${parentId ? `?parent_id=${parentId}` : ''}`);
    return response.data.data;
  },

  getDocumentById: async (documentId: number, userId: string) => {
    const response = await api.get(`/documents/${documentId}/${userId}`);
    return response.data.data;
  },

  createFolder: async (folderData: DocumentCreateInput) => {
    const response = await api.post('/documents/folder', folderData);
    return response.data;
  },

  uploadFiles: async (files: FormData, parentId?: number) => {
    const response = await api.post(`/documents/upload${parentId ? `?parent_id=${parentId}` : ''}`, files, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  updateDocument: async (documentData: DocumentUpdateInput) => {
    const response = await api.put('/documents', documentData);
    return response.data;
  },

  deleteDocument: async (documentId: number, userId: string) => {
    const response = await api.delete(`/documents/${documentId}/${userId}`);
    return response.data;
  },

  moveDocument: async (documentId: number, newParentId: number | null) => {
    const response = await api.put('/documents/move', { document_id: documentId, parent_id: newParentId });
    return response.data;
  },

  shareDocument: async (documentId: number, isShared: boolean) => {
    const response = await api.put('/documents/share', { document_id: documentId, is_shared: isShared });
    return response.data;
  },

  searchDocuments: async (userId: string, query: string) => {
    const response = await api.get(`/documents/search/${userId}?query=${query}`);
    return response.data.data;
  },

  getBreadcrumbPath: async (documentId: number) => {
    const response = await api.get(`/documents/path/${documentId}`);
    // Unwrap like the other endpoints — response.data is {status, message, data},
    // so returning it as-is (instead of response.data.data) handed the caller an
    // object instead of an array, breaking breadcrumbs.map().
    return response.data.data;
  },
};

export default documentsService; 